<template>
  <div class="nav">
    <el-row>
      <el-col :span="8">
        <div class="grid-content logoTop">
          <div>
            <div class="topLogo">
              <router-link to="/">
              <div style="width: 100%;height:100%">
                <img width="154px;" src="../assets/logo/logo.png" alt class="topLogoimg" />
              </div>
              </router-link>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="grid-content topNav" id="topNav">
          <el-menu
            :default-active="$route.path"
            class="el-menu-demo"
            mode="horizontal"
            text-color="#666666"
            active-text-color="#333333"
            @select="handleSelect"
            router
          >
            <!-- <el-menu-item index="1">关于我们</el-menu-item> -->
            <!-- <el-menu-item index="2">IP营销</el-menu-item> -->
            <el-submenu index="1">
              <template slot="title">
                <router-link to="/dongximuying">
                  <div id="contactUs" @click="backtop">关于我们</div>
                </router-link>
              </template>
              <el-menu-item index="/dongximuying">
                <router-link to>
                  <div id="contactUs" @click="backtop">公司简介</div>
                </router-link>
              </el-menu-item>
              <el-menu-item index="/kaenjianjie">
                <router-link to>
                  <div id="contactUs" @click="backtop">大事记</div>
                </router-link>
              </el-menu-item>
              <el-menu-item index="/yewufanwei">
                <router-link to>
                  <div id="contactUs" @click="backtop">业务范围</div>
                </router-link>
              </el-menu-item>
              <el-menu-item index="/supplychain">
                <router-link to>
                  <div id="contactUs" @click="backtop">供应链体系</div>
                </router-link>
              </el-menu-item>
              <el-menu-item index="/gongsirongyu">
                <router-link to>
                  <div id="contactUs" @click="backtop">公司荣誉</div>
                </router-link>
              </el-menu-item>
            </el-submenu>
            <el-submenu index="2">
              <template slot="title">
                <router-link to="/IPyingxiao">
                  <div id="contactUs" @click="backtop">IP营销</div>
                </router-link>
              </template>
              <el-menu-item index="/IPyingxiao">
                <router-link :to="{name:'IPyingxiao',params:{aa:1}}">
                  <div id="contactUs" @click="backtop">IP生态聚合</div>
                </router-link>
              </el-menu-item>
              <el-menu-item index="/celuechuangyi">
                <router-link to="/celuechuangyi">
                  <div id="contactUs" @click="backtop">IP创意设计</div>
                </router-link>
              </el-menu-item>
              <el-menu-item index="/kehuanlic">
                <router-link to="/kehuanlic">
                  <div id="contactUs" @click="backtop">整合优势资源</div>
                </router-link>
              </el-menu-item>
            </el-submenu>
            <!-- <el-submenu index="2">
              <template slot="title">
                <router-link to="/IPyingxiao">IP营销</router-link>
              </template>
              <el-menu-item index="">IP生态聚合</el-menu-item>
              <el-menu-item index="/IPyingxiao">
                <router-link :to="{name:'celuechuangyi',params:{a:0}}">IP创意设计</router-link>
              </el-menu-item>
              <el-menu-item index="/IPyingxiao">
                <router-link :to="{name:'kehuanli',params:{a:1}}">整合优势资源</router-link>
              </el-menu-item>
            </el-submenu>-->
            <!-- <el-submenu index="3"> -->
            <el-menu-item index="/chanpinjieshao" class="cpjs">
              <router-link to="/chanpinjieshao" id="chanpinjieshao">
                <div id="contactUs" @click="backtop">产品介绍</div>
              </router-link>
            </el-menu-item>
            <!-- <template slot="title">
                <router-link to="/chanpinjieshao" id="chanpinjieshao">
                  <div id="contactUs" @click="backtop">产品介绍</div>
                </router-link>
            </template>-->
            <!-- <el-menu-item index="/chanpinjieshao" id="anjia" @click="go">
                <router-link :to="{name:'chanpinjieshao',params:{a:0}}">安佳奶片机</router-link>
              </el-menu-item>
              <el-menu-item index="/chanpinjieshao" id="xiaowanju">
                <router-link :to="{name:'chanpinjieshao',params:{a:1}}">KFC超级飞侠小玩具</router-link>
              </el-menu-item>
              <el-menu-item index="/chanpinjieshao" id="laganxiang">
                <router-link :to="{name:'chanpinjieshao',params:{a:2}}">米奇亲子拉杆箱</router-link>
              </el-menu-item>
              <el-menu-item index="/chanpinjieshao" id="lanya">
                <router-link :to="{name:'chanpinjieshao',params:{a:3}}">米奇Magic Ball蓝牙音箱</router-link>
            </el-menu-item>-->
            <!-- </el-submenu> -->
            <!-- <el-submenu index="4">
              <template slot="title">
                <router-link to="/kehuanli" id="kehuanli">
                  <div @click="backtop">客户案例</div>
                </router-link>
              </template>
              <el-menu-item index="/kehuanli" id="xiaohuangren">
                <router-link :to="{name:'kehuanli',params:{b:3}}">2018年KFC圣诞小黄人</router-link>
              </el-menu-item>
              <el-menu-item index="/kehuanli" id="shiziwang">
                <router-link :to="{name:'kehuanli',params:{b:2}}">狮子王真人版电影定制款</router-link>
              </el-menu-item>
              <el-menu-item index="/kehuanli" id="baishi">
                <router-link :to="{name:'kehuanli',params:{b:0}}">2019年百事可乐X星球大战</router-link>
              </el-menu-item>
              <el-menu-item index="/kehuanli" id="anjianai">
                <router-link :to="{name:'kehuanli',params:{b:1}}">2019年安佳奶片机</router-link>
              </el-menu-item>
            </el-submenu>-->
            <el-menu-item index="/kehuanli" class="khal">
              <router-link to="/kehuanli" id="kehuanli">
                <div @click="backtop">客户案例</div>
              </router-link>
            </el-menu-item>
            <el-submenu index="5">
              <template slot="title">
                <router-link :to="{name:'About',params:{c:'first'}}">
                  <div id="contactUs" @click="backtop">联系我们</div>
                </router-link>
              </template>
              <el-menu-item index="/AboutUs" id="lianxiwomen">
                <router-link :to="{name:'About',params:{c:'first'}}">联系我们</router-link>
              </el-menu-item>
              <el-menu-item index="/AboutUs" id="jiaruwomen">
                <router-link :to="{name:'About',params:{c:'second'}}">加入我们</router-link>
              </el-menu-item>
            </el-submenu>
          </el-menu>
        </div>
      </el-col>
      <el-col :span="4">
        <div class="grid-content"></div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  data() {
    return {
      msg: "Welcome to Your Vue.js App",
      radio1: "关于我们",
      activeIndex: "1",
      value: "1"
    };
  },
  methods: {
    //   go() {

    //            this.$emit('func',this.value)
    // console.log(this.value)
    //   },
    backtop() {
      document.documentElement.scrollTop = 0;
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.nav {
  width: 100%;
  position: absolute;
  min-width: 1240px;
  z-index: 1000;
  height: 56px;
  background: transparent;
  /* opacity: 0.25; */
}

.logoTop {
  position: absolute;
  width: 100%;
  & > div {
    width: 65%;
    margin: 0 auto;
    @media screen and (min-width: 140px){
      min-width: 1050px!important;
    }
    @media screen and (min-width: 1920px){
      min-width: 1240px!important;
    }
  }
}
.backhome {
  height: 56px;
  position: fixed;
  right: 100px;
  line-height: 75px;
  img {
    height: 50%;
  }
}
#topNav {
  width: 100%;
  position: fixed;
  left: 0;
  padding-left: 33.5%;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05) !important;
  li {
    width: 150px !important;
  }
}
.topNav {
  position: fixed;
  background-color: #fff;
  min-width: 800px;
}
.el-col-12 {
  min-width: 800px;
}
.el-menu {
  background: transparent;
}
.el-menu--horizontal > .el-menu-item:not(.is-disabled):focus,
.el-menu--horizontal > .el-menu-item:not(.is-disabled):hover,
.el-menu--horizontal > .el-submenu .el-submenu__title:hover {
  background: transparent;
}
.el-row {
  margin-bottom: 20px;
}
.el-col {
  border-radius: 4px;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
}
/* .el-menu--horizontal > .el-menu-item {
  color: #fff;
} */
.el-menu-item {
  padding: 0;
  margin: 0;
}
.el-menu--horizontal > .el-menu-item {
  height: 50px;
}
.el-menu--horizontal > .el-menu-item.is-active {
  border-bottom: 2px solid #fce04f;
}
.topLogo {
  width: 176px;
  height: 156px;
  background: rgba(252, 224, 79, 1);
  /* text-align: center; */
  /* line-height: 212px; */
  position: relative;
  z-index: 10;
}
.topLogoimg {
  width: 154px;
  height: 154px;
  position: relative;
  top: 50%;
  margin-top: -82px;
}
.el-menu--horizontal > .el-menu-item {
  color: #fff;
}
a {
  text-decoration: none;
  color: #666;
}
// .el-menu-item{
//   height: 56px !important;
  
// }
.el-menu-item #contactUS{
  width: 50px !important;
}
.cpjs{
  height: 56px !important;
  div{
    width: 50px;
  }
}
.khal{
  height: 56px !important;
  div{
    width: 50px;
  }
}
.el-menu-item div{
  font-family: "微软雅黑";
  color: #333;
}
</style>
<style  lang="less">
.el-radio-button__orig-radio:checked + .el-radio-button__inner {
  color: rgba(255, 255, 255, 1);
  font-weight: bold;
  background-color: #fff;
  border-bottom: yellow;
  border: none;
}
.el-menu-item{
  margin: 0 !important;
  font-family: "微软雅黑";
}
.el-icon-arrow-down {
  display: none;
}
.el-menu.el-menu--horizontal {
  border: none;
}
.el-submenu__title {
  margin: 0 20px;
}
.el-menu--popup-right-start {
  margin: 0;
}
.el-menu-item:hover li {
  background-color: aqua;
}
.el-menu--popup {
  padding: 0;
}
.el-submenu__title:hover {
  color: #333;
}
.el-menu-item:hover {
  color: #333;
}
.is-active div {
  border-bottom-color: #fce04f !important;
}
.el-menu.el-menu--horizontal {
  border: none !important;
}

.el-submenu__title {
  padding: 0 !important;
  height: 30px !important;
  display: flex;
  align-items: center;
}
.el-menu--horizontal > .el-submenu .el-submenu__title {
  height: 40px;
  line-height: 56px;
}
.el-submenu {
  height: 56px;
  display: flex;
  align-items: center;
}
.el-menu--popup-bottom-start {
  margin-top: -10px;
}
// .el-menu-item{
//   margin: 0 !important;
//   height: 56px !important;
//   div{
//     height: 40px !important;
//     // line-height: 56px !important;
//     text-align: left !important;
//     width: 56px !important;
//     padding-bottom: 2px !important;
//   }
// }
// .is-active #contactUs{
//   border-bottom: 1px solid !important;
//   border-bottom-color:#fce04f !important;
// }
.is-active{
  border: none!important;
  // padding-bottom: 5px !important;
}
.el-menu--horizontal>.el-menu-item{
  line-height: 56px !important;
}

</style>
